

import React, { useState } from 'react';
import '../assets/main.css';
import Calendar from './Calendar';
import Appoinments from './Tabs/Appointment';
import HistoryPatient from './Tabs/HistoryPatient';
import RecordsPatient from './Tabs/RecordsPatient';
import ReportsPatient from './Tabs/ReportsPatient';
import PharmacyPatient from './Tabs/PharmacyPatient';
import { getUserName } from '../helper/access';

const tabs = ['Appoinment', 'History', 'Reports', 'Pharmacy'];

const PatientComponent = () => {
  const [activeTab, setActiveTab] = useState('Appoinment');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Appoinment':
        return <Appoinments />;
      case 'History':
        return <HistoryPatient />;
      case 'Reports':
        return <RecordsPatient />;
      case 'Pharmacy':
        return <PharmacyPatient />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="doctor-header">
        <div className="header-title">Cliqnconnect</div>
        <div className="header-actions">
          <div className="doctor-profile"></div>
          <div>
            <div className="doctor-name">{getUserName()}</div>
          </div>
        </div>
      </div>

      <div className="vertical-tab-container">
        <div className="tab-sidebar">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="tab-main-content">
          <h3>{activeTab}</h3>
          <div className="scrollable-content">
            {renderTabContent()}
          </div>
        </div>

        {/* <div className="tab-right-sidebar">
          <Calendar />
        </div> */}
      </div>
    </>
  );
};

export default PatientComponent;
